export const iconFontAwesomeConnectivityWifi = (
	<i className="fa-solid fa-wifi"></i>
);
